export class ValidationPattern {
  public static VOLLER_GELDBETRAG = '^\-?[1-9][0-9]*$|^0$';
  public static VOLLER_POSITIVER_GELDBETRAG = '^[1-9][0-9]*$|^0$';
  public static UST_ID = '^[A-Z]{2}[a-zA-Z0-9+*]{5,12}$';
  public static STEUERNUMMER = '^([0-9]{4})0[0-9]{8}$';
  public static IDENTIFIKATION_NUMMER = '^(?=.{7,14}$)[A-Z]{2}[a-zA-Z0-9\\+\\*]*';
  public static NUMBER = '^\\d*([\\.|,]\\d*)?$';
  public static INTEGER = '^\\d+$';
  public static ERIC_DECIMAL = '^\\d*([\\.|,]\\d{2,2})?$';
  public static POSITIVE_DECIMAL = '^([1-9][0-9]*)|(\\d*[\\.|,]\\d*)$';
  public static POSITIV_INTEGER = '^(?!0\\d)\\d*$';
  public static WIRTSCHAFTS_ID = '^DE[0-9]{9}-(0000[1-9]|000[1-9][0-9]|00[1-9][0-9]{2}|0[1-9][0-9]{3}|[1-9][0-9]{4})$';
}
